import React from 'react';
import {useSelector} from 'react-redux';
import RequireAuth from '../../app/components/route/RequireAuth';
import {Role} from '../../utils/roles';

/**
 * Garde des écrans Pilotage rendus hors gabarit extranet (`protected: false` dans routes.js, donc sans le
 * RequireAuth de Layout) : même contrôle, ROLE_ADMIN et ROLE_EXPLOITANT, redirection /login.
 */
export default function GardeModule({children}) {
    const loggedIn = useSelector((state) => state.authentication.loggedIn);
    const user = useSelector((state) => state.authentication.user);
    return (
        <RequireAuth loggedIn={loggedIn} role={user ? user.roles : ''} restrictedRoles={[Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT]} redirectTo="/login">
            {children}
        </RequireAuth>
    );
}
